import type { AuthSession } from '../ports';

export type AuthorizedFetch = (input: Request | string, init?: RequestInit) => Promise<Response>;

const ALREADY_RETRIED_AFTER_REFRESH_HEADER = 'x-ngsos-retried';

export function createAuthorizedFetch(
  auth: AuthSession,
  baseFetch: AuthorizedFetch = fetch,
): AuthorizedFetch {
  return async (input, init) => {
    const request = new Request(input, init);
    const token = await auth.getAccessToken();
    if (token != null && !request.headers.has('Authorization')) {
      request.headers.set('Authorization', `Bearer ${token}`);
    }

    const response = await baseFetch(request.clone());
    if (response.status !== 401 || request.headers.has(ALREADY_RETRIED_AFTER_REFRESH_HEADER)) {
      return response;
    }

    const fresh = await auth.refreshOrNotifySessionExpired();
    if (fresh == null) {
      return response;
    }

    const retried = new Request(request, {});
    retried.headers.set('Authorization', `Bearer ${fresh}`);
    retried.headers.set(ALREADY_RETRIED_AFTER_REFRESH_HEADER, '1');
    return baseFetch(retried);
  };
}
